<template>
    <div class="modal fade text-left" :id="id" tabindex="-1" role="dialog" aria-labelledby="myModalLabel1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title " id="myModalLabel17">{{ reportStore.getAccountDetail(account).furnisher_name }}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="table-responsive">
                        <table class="table table-success table-striped table-hover mb-0">
                            <thead class="thead-primary">
                                <tr>
                                    <th style="width:100px"></th>
                                    <th style="width:100px">
                                        <img :src="reportStore.images.transunion" alt="image" width="75" height="75" class="d-block">
                                    </th>
                                    <th style="width:100px">
                                        <img :src="reportStore.images.experian" alt="image" width="75" height="75" class="d-block">
                                    </th>
                                    <th style="width:100px">
                                        <img :src="reportStore.images.equifax" alt="image" width="75" height="75" class="d-block">
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="table-striped">
                                <tr>
                                    <td>Account Number:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[0].account_number }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[0].account_number != reportStore.getDeletedRecord(account)[0].account_number)">
                                            {{ reportStore.getDeletedRecord(account)[0].account_number }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[1].account_number }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[1].account_number != reportStore.getDeletedRecord(account)[1].account_number)">
                                            {{ reportStore.getDeletedRecord(account)[1].account_number }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[2].account_number }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[2].account_number != reportStore.getDeletedRecord(account)[2].account_number)">
                                            {{ reportStore.getDeletedRecord(account)[2].account_number }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Account Status:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[0].account_status }}
                                            <small
                                                v-if="reportStore.isViolation(account, 0, 'account_status', 'account_status').isViolation"
                                                class="text-danger"
                                                :id="`violation-account-status-${id}-${account[0].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-account-status-${id}-${account[0].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 0, 'account_status', 'account_status').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[0].account_status != reportStore.getDeletedRecord(account)[0].account_status)">
                                            {{ reportStore.getDeletedRecord(account)[0].account_status }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[1].account_status }}
                                            <small
                                                v-if="reportStore.isViolation(account, 1, 'account_status', 'account_status').isViolation"
                                                class="text-danger"
                                                :id="`violation-account-status-${id}-${account[1].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-account-status-${id}-${account[1].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 1, 'account_status', 'account_status').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[1].account_status != reportStore.getDeletedRecord(account)[1].account_status)">
                                            {{ reportStore.getDeletedRecord(account)[1].account_status }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[2].account_status }}
                                            <small
                                                v-if="reportStore.isViolation(account, 2, 'account_status', 'account_status').isViolation"
                                                class="text-danger"
                                                :id="`violation-account-status-${id}-${account[2].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-account-status-${id}-${account[2].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 2, 'account_status', 'account_status').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[2].account_status != reportStore.getDeletedRecord(account)[2].account_status)">
                                            {{ reportStore.getDeletedRecord(account)[2].account_status }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Account Type:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[0].account_type }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[0].account_type != reportStore.getDeletedRecord(account)[0].account_type)">
                                            {{ reportStore.getDeletedRecord(account)[0].account_type }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[1].account_type }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[1].account_type != reportStore.getDeletedRecord(account)[1].account_type)">
                                            {{ reportStore.getDeletedRecord(account)[1].account_type }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[2].account_type }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[2].account_type != reportStore.getDeletedRecord(account)[2].account_type)">
                                            {{ reportStore.getDeletedRecord(account)[2].account_type }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Account Detail:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[0].account_detail }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[0].account_detail != reportStore.getDeletedRecord(account)[0].account_detail)">
                                            {{ reportStore.getDeletedRecord(account)[0].account_detail }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[1].account_detail }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[1].account_detail != reportStore.getDeletedRecord(account)[1].account_detail)">
                                            {{ reportStore.getDeletedRecord(account)[1].account_detail }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[2].account_detail }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[2].account_detail != reportStore.getDeletedRecord(account)[2].account_detail)">
                                            {{ reportStore.getDeletedRecord(account)[2].account_detail }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Bureau Code:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[0].bureau_code }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[0].bureau_code != reportStore.getDeletedRecord(account)[0].bureau_code)">
                                            {{ reportStore.getDeletedRecord(account)[0].bureau_code }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[1].bureau_code }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[1].bureau_code != reportStore.getDeletedRecord(account)[1].bureau_code)">
                                            {{ reportStore.getDeletedRecord(account)[1].bureau_code }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[2].bureau_code }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[2].bureau_code != reportStore.getDeletedRecord(account)[2].bureau_code)">
                                            {{ reportStore.getDeletedRecord(account)[2].bureau_code }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Monthly Payment:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[0].monthly_payment }}
                                            <small
                                                v-if="reportStore.isViolation(account, 0, 'monthly_payment', 'monthly_payment').isViolation"
                                                class="text-danger"
                                                :id="`violation-monthly-payment-${id}-${account[0].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-monthly-payment-${id}-${account[0].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 0, 'monthly_payment', 'monthly_payment').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[0].monthly_payment != reportStore.getDeletedRecord(account)[0].monthly_payment)">
                                            {{ reportStore.getDeletedRecord(account)[0].monthly_payment }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[1].monthly_payment }}
                                            <small
                                                v-if="reportStore.isViolation(account, 1, 'monthly_payment', 'monthly_payment').isViolation"
                                                class="text-danger"
                                                :id="`violation-monthly-payment-${id}-${account[1].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-monthly-payment-${id}-${account[1].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 1, 'monthly_payment', 'monthly_payment').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[1].monthly_payment != reportStore.getDeletedRecord(account)[1].monthly_payment)">
                                            {{ reportStore.getDeletedRecord(account)[1].monthly_payment }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[2].monthly_payment }}
                                            <small
                                                v-if="reportStore.isViolation(account, 2, 'monthly_payment', 'monthly_payment').isViolation"
                                                class="text-danger"
                                                :id="`violation-monthly-payment-${id}-${account[2].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-monthly-payment-${id}-${account[2].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 2, 'monthly_payment', 'monthly_payment').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[2].monthly_payment != reportStore.getDeletedRecord(account)[2].monthly_payment)">
                                            {{ reportStore.getDeletedRecord(account)[2].monthly_payment }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Payment Status:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[0].payment_status }}
                                            <small
                                                v-if="reportStore.isViolation(account, 0, 'payment_status', 'payment_status').isViolation"
                                                class="text-danger"
                                                :id="`violation-payment-status-${id}-${account[0].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-payment-status-${id}-${account[0].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 0, 'payment_status', 'payment_status').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[0].payment_status != reportStore.getDeletedRecord(account)[0].payment_status)">
                                            {{ reportStore.getDeletedRecord(account)[0].payment_status }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[1].payment_status }}
                                            <small
                                                v-if="reportStore.isViolation(account, 1, 'payment_status', 'payment_status').isViolation"
                                                class="text-danger"
                                                :id="`violation-payment-status-${id}-${account[1].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-payment-status-${id}-${account[1].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 1, 'payment_status', 'payment_status').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[1].payment_status != reportStore.getDeletedRecord(account)[1].payment_status)">
                                            {{ reportStore.getDeletedRecord(account)[1].payment_status }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[2].payment_status }}
                                            <small
                                                v-if="reportStore.isViolation(account, 2, 'payment_status', 'payment_status').isViolation"
                                                class="text-danger"
                                                :id="`violation-payment-status-${id}-${account[2].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-payment-status-${id}-${account[2].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 2, 'payment_status', 'payment_status').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[2].payment_status != reportStore.getDeletedRecord(account)[2].payment_status)">
                                            {{ reportStore.getDeletedRecord(account)[2].payment_status }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Past Due:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[0].past_due }}
                                            <small
                                                v-if="reportStore.isViolation(account, 0, 'past_due', 'past_due').isViolation"
                                                class="text-danger"
                                                :id="`violation-past-due-${id}-${account[0].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-past-due-${id}-${account[0].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 0, 'past_due', 'past_due').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[0].past_due != reportStore.getDeletedRecord(account)[0].past_due)">
                                            {{ reportStore.getDeletedRecord(account)[0].past_due }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[1].past_due }}
                                            <small
                                                v-if="reportStore.isViolation(account, 1, 'past_due', 'past_due').isViolation"
                                                class="text-danger"
                                                :id="`violation-past-due-${id}-${account[1].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-past-due-${id}-${account[1].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 1, 'past_due', 'past_due').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[1].past_due != reportStore.getDeletedRecord(account)[1].past_due)">
                                            {{ reportStore.getDeletedRecord(account)[1].past_due }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[2].past_due }}
                                            <small
                                                v-if="reportStore.isViolation(account, 2, 'past_due', 'past_due').isViolation"
                                                class="text-danger"
                                                :id="`violation-past-due-${id}-${account[2].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-past-due-${id}-${account[2].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 2, 'past_due', 'past_due').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[2].past_due != reportStore.getDeletedRecord(account)[2].past_due)">
                                            {{ reportStore.getDeletedRecord(account)[2].past_due }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Date Opened:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ formatDate(account[0].date_opened, reportStore.dateFormat) }}
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                reportStore.getDeletedRecord(account).length > 0
                                                &&
                                                (account[0].date_opened != reportStore.getDeletedRecord(account)[0].date_opened)
                                            "
                                        >
                                            {{ formatDate(reportStore.getDeletedRecord(account)[0].date_opened, reportStore.dateFormat) }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ formatDate(account[1].date_opened, reportStore.dateFormat) }}
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                reportStore.getDeletedRecord(account).length > 0
                                                &&
                                                (account[1].date_opened != reportStore.getDeletedRecord(account)[1].date_opened)
                                            "
                                        >
                                            {{ formatDate(reportStore.getDeletedRecord(account)[1].date_opened, reportStore.dateFormat) }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ formatDate(account[2].date_opened, reportStore.dateFormat) }}
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                reportStore.getDeletedRecord(account).length > 0
                                                &&
                                                (account[2].date_opened != reportStore.getDeletedRecord(account)[2].date_opened)
                                            "
                                        >
                                            {{ formatDate(reportStore.getDeletedRecord(account)[2].date_opened, reportStore.dateFormat) }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Date Last Active:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ formatDate(account[0].date_last_active, reportStore.dateFormat) }}
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                reportStore.getDeletedRecord(account).length > 0
                                                &&
                                                (account[0].date_last_active != reportStore.getDeletedRecord(account)[0].date_last_active)
                                            "
                                        >
                                            {{ formatDate(reportStore.getDeletedRecord(account)[0].date_last_active, reportStore.dateFormat) }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ formatDate(account[1].date_last_active, reportStore.dateFormat) }}
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                reportStore.getDeletedRecord(account).length > 0
                                                &&
                                                (account[1].date_last_active != reportStore.getDeletedRecord(account)[1].date_last_active)
                                            "
                                        >
                                            {{ formatDate(reportStore.getDeletedRecord(account)[1].date_last_active, reportStore.dateFormat) }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ formatDate(account[2].date_last_active, reportStore.dateFormat) }}
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                reportStore.getDeletedRecord(account).length > 0
                                                &&
                                                (account[2].date_last_active != reportStore.getDeletedRecord(account)[2].date_last_active)
                                            "
                                        >
                                            {{ formatDate(reportStore.getDeletedRecord(account)[2].date_last_active, reportStore.dateFormat) }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Date Last Payment:
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ formatDate(account[0].date_last_payment, reportStore.dateFormat) }}
                                            <small
                                                v-if="reportStore.isViolation(account, 0, 'date_last_payment', 'date').isViolation"
                                                class="text-danger"
                                                :id="`violation-date-last-payment-${id}-${account[0].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-date-last-payment-${id}-${account[0].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 0, 'date_last_payment', 'date').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                reportStore.getDeletedRecord(account).length > 0
                                                &&
                                                (account[0].date_last_payment != reportStore.getDeletedRecord(account)[0].date_last_payment)
                                            "
                                        >
                                            {{ formatDate(reportStore.getDeletedRecord(account)[0].date_last_payment, reportStore.dateFormat) }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ formatDate(account[1].date_last_payment, reportStore.dateFormat) }}
                                            <small
                                                v-if="reportStore.isViolation(account, 1, 'date_last_payment', 'date').isViolation"
                                                class="text-danger"
                                                :id="`violation-date-last-payment-${id}-${account[1].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-date-last-payment-${id}-${account[1].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 1, 'date_last_payment', 'date').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                reportStore.getDeletedRecord(account).length > 0
                                                &&
                                                (account[1].date_last_payment != reportStore.getDeletedRecord(account)[1].date_last_payment)
                                            "
                                        >
                                            {{ formatDate(reportStore.getDeletedRecord(account)[1].date_last_payment, reportStore.dateFormat) }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ formatDate(account[2].date_last_payment, reportStore.dateFormat) }}
                                            <small
                                                v-if="reportStore.isViolation(account, 2, 'date_last_payment', 'date').isViolation"
                                                class="text-danger"
                                                :id="`violation-date-last-payment-${id}-${account[2].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-date-last-payment-${id}-${account[2].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 2, 'date_last_payment', 'date').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                reportStore.getDeletedRecord(account).length > 0
                                                &&
                                                (account[2].date_last_payment != reportStore.getDeletedRecord(account)[2].date_last_payment)
                                            "
                                        >
                                            {{ formatDate(reportStore.getDeletedRecord(account)[2].date_last_payment, reportStore.dateFormat) }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>High Credit:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[0].high_credit }}
                                            <small
                                                v-if="reportStore.isViolation(account, 0, 'high_credit', 'high_credit').isViolation"
                                                class="text-danger"
                                                :id="`violation-high-credit-${id}-${account[0].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-high-credit-${id}-${account[0].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 0, 'high_credit', 'high_credit').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                reportStore.getDeletedRecord(account).length > 0
                                                &&
                                                (account[0].high_credit != reportStore.getDeletedRecord(account)[0].high_credit)
                                            "
                                        >
                                            {{ reportStore.getDeletedRecord(account)[0].high_credit }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[1].high_credit }}
                                            <small
                                                v-if="reportStore.isViolation(account, 1, 'high_credit', 'high_credit').isViolation"
                                                class="text-danger"
                                                :id="`violation-high-credit-${id}-${account[1].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-high-credit-${id}-${account[1].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 1, 'high_credit', 'high_credit').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                reportStore.getDeletedRecord(account).length > 0
                                                &&
                                                (account[1].high_credit != reportStore.getDeletedRecord(account)[1].high_credit)
                                            "
                                        >
                                            {{ reportStore.getDeletedRecord(account)[1].high_credit }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[2].high_credit }}
                                            <small
                                                v-if="reportStore.isViolation(account, 2, 'high_credit', 'high_credit').isViolation"
                                                class="text-danger"
                                                :id="`violation-high-credit-${id}-${account[2].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-high-credit-${id}-${account[2].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 2, 'high_credit', 'high_credit').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                reportStore.getDeletedRecord(account).length > 0
                                                &&
                                                (account[2].high_credit != reportStore.getDeletedRecord(account)[2].high_credit)
                                            "
                                        >
                                            {{ reportStore.getDeletedRecord(account)[2].high_credit }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Credit Limit:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[0].credit_limit }}
                                            <small
                                                v-if="reportStore.isViolation(account, 0, 'credit_limit', 'credit_limit').isViolation"
                                                class="text-danger"
                                                :id="`violation-credit-limit-${id}-${account[0].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-credit-limit-${id}-${account[0].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 0, 'credit_limit', 'credit_limit').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                reportStore.getDeletedRecord(account).length > 0
                                                &&
                                                (account[0].credit_limit != reportStore.getDeletedRecord(account)[0].credit_limit)
                                            "
                                        >
                                            {{ reportStore.getDeletedRecord(account)[0].credit_limit }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[1].credit_limit }}
                                            <small
                                                v-if="reportStore.isViolation(account, 1, 'credit_limit', 'credit_limit').isViolation"
                                                class="text-danger"
                                                :id="`violation-credit-limit-${id}-${account[1].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-credit-limit-${id}-${account[1].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 1, 'credit_limit', 'credit_limit').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                reportStore.getDeletedRecord(account).length > 0
                                                &&
                                                (account[1].credit_limit != reportStore.getDeletedRecord(account)[1].credit_limit)
                                            "
                                        >
                                            {{ reportStore.getDeletedRecord(account)[1].credit_limit }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[2].credit_limit }}
                                            <small
                                                v-if="reportStore.isViolation(account, 2, 'credit_limit', 'credit_limit').isViolation"
                                                class="text-danger"
                                                :id="`violation-credit-limit-${id}-${account[2].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-credit-limit-${id}-${account[2].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 2, 'credit_limit', 'credit_limit').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                reportStore.getDeletedRecord(account).length > 0
                                                &&
                                                (account[2].credit_limit != reportStore.getDeletedRecord(account)[2].credit_limit)
                                            "
                                        >
                                            {{ reportStore.getDeletedRecord(account)[2].credit_limit }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Balance Owed:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[0].balance }}
                                            <small
                                                v-if="reportStore.isViolation(account, 0, 'balance', 'balance').isViolation"
                                                class="text-danger"
                                                :id="`violation-balance-${id}-${account[0].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-balance-${id}-${account[0].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 0, 'balance', 'balance').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                reportStore.getDeletedRecord(account).length > 0
                                                &&
                                                (account[0].balance != reportStore.getDeletedRecord(account)[0].balance)
                                            "
                                        >
                                            {{ reportStore.getDeletedRecord(account)[0].balance }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[1].balance }}
                                            <small
                                                v-if="reportStore.isViolation(account, 1, 'balance', 'balance').isViolation"
                                                class="text-danger"
                                                :id="`violation-balance-${id}-${account[1].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-balance-${id}-${account[1].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 1, 'balance', 'balance').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                reportStore.getDeletedRecord(account).length > 0
                                                &&
                                                (account[1].balance != reportStore.getDeletedRecord(account)[1].balance)
                                            "
                                        >
                                            {{ reportStore.getDeletedRecord(account)[1].balance }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[2].balance }}
                                            <small
                                                v-if="reportStore.isViolation(account, 2, 'balance', 'balance').isViolation"
                                                class="text-danger"
                                                :id="`violation-balance-${id}-${account[2].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-balance-${id}-${account[2].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 2, 'balance', 'balance').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                reportStore.getDeletedRecord(account).length > 0
                                                &&
                                                (account[2].balance != reportStore.getDeletedRecord(account)[2].balance)
                                            "
                                        >
                                            {{ reportStore.getDeletedRecord(account)[2].balance }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Last Reported:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ formatDate(account[0].last_reported, reportStore.dateFormat) }}
                                            <small
                                                v-if="reportStore.isViolation(account, 0, 'last_reported', 'date').isViolation"
                                                class="text-danger"
                                                :id="`violation-last-reported-${id}-${account[0].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-last-reported-${id}-${account[0].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 0, 'last_reported', 'date').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                reportStore.getDeletedRecord(account).length > 0
                                                &&
                                                (account[0].last_reported != reportStore.getDeletedRecord(account)[0].last_reported)
                                            "
                                        >
                                            {{ formatDate(reportStore.getDeletedRecord(account)[0].last_reported, reportStore.dateFormat) }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ formatDate(account[1].last_reported, reportStore.dateFormat) }}
                                            <small
                                                v-if="reportStore.isViolation(account, 1, 'last_reported', 'date').isViolation"
                                                class="text-danger"
                                                :id="`violation-last-reported-${id}-${account[1].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-last-reported-${id}-${account[1].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 1, 'last_reported', 'date').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                reportStore.getDeletedRecord(account).length > 0
                                                &&
                                                (account[1].last_reported != reportStore.getDeletedRecord(account)[1].last_reported)
                                            "
                                        >
                                            {{ formatDate(reportStore.getDeletedRecord(account)[1].last_reported, reportStore.dateFormat) }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ formatDate(account[2].last_reported, reportStore.dateFormat) }}
                                            <small
                                                v-if="reportStore.isViolation(account, 2, 'last_reported', 'date').isViolation"
                                                class="text-danger"
                                                :id="`violation-last-reported-${id}-${account[2].id}`"
                                            >
                                                Violation
                                                <b-popover
                                                    :target="`violation-last-reported-${id}-${account[2].id}`"
                                                    placement="top"
                                                    triggers="hover"
                                                    :html="true"
                                                >
                                                    <template #title>Violation</template>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <p>
                                                                {{ reportStore.isViolation(account, 2, 'last_reported', 'date').message }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-popover>
                                            </small>
                                        </p>
                                        <p
                                            class="mb-0 text-danger"
                                            v-if="
                                                reportStore.reports[email].haveOldReport
                                                &&
                                                reportStore.getDeletedRecord(account).length > 0
                                                &&
                                                (account[2].last_reported != reportStore.getDeletedRecord(account)[2].last_reported)
                                            "
                                        >
                                            {{ formatDate(reportStore.getDeletedRecord(account)[2].last_reported, reportStore.dateFormat) }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Month Term:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[0].number_of_months }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[0].number_of_months != reportStore.getDeletedRecord(account)[0].number_of_months)">
                                            {{ reportStore.getDeletedRecord(account)[0].number_of_months }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[1].number_of_months }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[1].number_of_months != reportStore.getDeletedRecord(account)[1].number_of_months)">
                                            {{ reportStore.getDeletedRecord(account)[1].number_of_months }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[2].number_of_months }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[2].number_of_months != reportStore.getDeletedRecord(account)[2].number_of_months)">
                                            {{ reportStore.getDeletedRecord(account)[2].number_of_months }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Comments:</td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[0].comments }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[0].comments != reportStore.getDeletedRecord(account)[0].comments)">
                                            {{ reportStore.getDeletedRecord(account)[0].comments }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[1].comments }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[1].comments != reportStore.getDeletedRecord(account)[1].comments)">
                                            {{ reportStore.getDeletedRecord(account)[1].comments }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mb-0">
                                            {{ account[2].comments }}
                                        </p>
                                        <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedRecord(account).length > 0 && (account[2].comments != reportStore.getDeletedRecord(account)[2].comments)">
                                            {{ reportStore.getDeletedRecord(account)[2].comments }}
                                            <span class="text-danger">
                                                (Updated)
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer justify-content-start">
                    <payment-history :account="account" :account-type="accountType" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { useReportStore } from '../../../stores/ReportStore.js'
    import { BPopover, BButton } from 'bootstrap-vue-3'
    import { formatDate } from '../../../utilities/_helpers'
    export default {
        mounted() {
        },
        components: {
            BPopover,
            BButton
        },
        props: {
            account: {
                type: [Array, Object]
            },
            id: String,
            accountType: String,
            email: String
        },
        setup() {
            return {
                reportStore: useReportStore(),
                formatDate: formatDate,
            }
        },
    }
</script>
